/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decode a JSON Web Token`)
};

const es_jw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decodificar un JSON Web Token`)
};

const de_jw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein JSON Web Token dekodieren`)
};

const nl_jw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een JSON Web Token decoderen`)
};

const fr_jw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décoder un jeton JWT`)
};

const it_jw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decodifica un JSON Web Token`)
};

const pt_br2_jw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decodificar um JSON Web Token`)
};

const pt_jw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descodifique um JSON Web Token`)
};

const ja_jw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Web Tokenをデコードする`)
};

const zh_jw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解码一个 JSON Web Token`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_nav_main_desc", locale)
	if (locale === "en") return en_jw_nav_main_desc(inputs)
	if (locale === "es") return es_jw_nav_main_desc(inputs)
	if (locale === "de") return de_jw_nav_main_desc(inputs)
	if (locale === "nl") return nl_jw_nav_main_desc(inputs)
	if (locale === "fr") return fr_jw_nav_main_desc(inputs)
	if (locale === "it") return it_jw_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_jw_nav_main_desc(inputs)
	if (locale === "pt") return pt_jw_nav_main_desc(inputs)
	if (locale === "ja") return ja_jw_nav_main_desc(inputs)
	return zh_jw_nav_main_desc(inputs)
};